namespace GeniuzPOS.Supplier {
    export interface CsSupplTypeRow {
        Id?: number;
        SupplType?: number;
        SupplTypeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsSupplTypeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Supplier.CsSupplType';
        export const lookupKey = 'Supplier.CsSupplType';

        export function getLookup(): Q.Lookup<CsSupplTypeRow> {
            return Q.getLookup<CsSupplTypeRow>('Supplier.CsSupplType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ผู้จำหน่าย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SupplType = "SupplType",
            SupplTypeName = "SupplTypeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
